import { render, staticRenderFns } from "./SurrogateImportStats.vue?vue&type=template&id=783895ee&"
import script from "./SurrogateImportStats.vue?vue&type=script&lang=js&"
export * from "./SurrogateImportStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports